import Vue from 'vue';
import Vuex from 'vuex';
import { authentication } from '@/modules/authentication/store';
import { analysis } from '@/modules/analysis/store';
import { home } from '@/modules/home/store';
import { barcode } from '@/modules/barcode/store';
import { nomenclature } from '@/modules/nomenclature/store';
import { results } from '@/modules/results/store';

Vue.use(Vuex);

function getState() {
  return {
    packageVersion: process.env.PACKAGE_VERSION || '0'
    // eslint-disable-next-line
  } as any;
}

export default new Vuex.Store({
  state: getState(),
  mutations: {
    clearState: (): void => {
      authentication.mutations.clearState(authentication.state);
      analysis.mutations.clearState(analysis.state);
      home.mutations.clearState(home.state);
      barcode.mutations.clearState(barcode.state);
      nomenclature.mutations.clearState(nomenclature.state);
      results.mutations.clearState(results.state);
    }
  },
  modules: { authentication, analysis, home, barcode, nomenclature, results },
  getters: {
    appVersion: (state) => {
      return state.packageVersion;
    }
  }
});
